import { type Patient, isRemovedPatient } from '@assist/core';
import { useEffect, useState } from 'preact/hooks';
import { app, clock } from '../controller.js';
import { go, useApp } from '../hooks.js';
import { t } from '../i18n.js';
import { ageOf, displayName, mrnOf } from '../patient.js';

export function Patients() {
  const a = useApp();
  const [q, setQ] = useState('');
  const [rows, setRows] = useState<Patient[] | null>(null);
  // biome-ignore lint/correctness/useExhaustiveDependencies: re-run when sync status changes
  useEffect(() => {
    let live = true;
    void app.session?.searchPatients(q, 100).then((r) => {
      if (live) setRows(r.filter((p) => !isRemovedPatient(p)));
    });
    return () => {
      live = false;
    };
  }, [q, a.status]);
  const today = clock.today();
  return (
    <div class="card">
      <div class="dhead">
        <div>
          <h3>{t.navFind}</h3>
        </div>
        <button type="button" class="act" onClick={() => go('register')}>
          + {t.registerPatient}
        </button>
      </div>
      <input
        class="search"
        type="search"
        placeholder={t.searchPatients}
        aria-label={t.searchPatients}
        value={q}
        onInput={(e) => setQ(e.currentTarget.value)}
      />
      {rows && rows.length === 0 ? <p class="empty">{q ? t.noMatches : t.noPatients}</p> : null}
      <ul class="plist">
        {(rows ?? []).map((p) => {
          const age = ageOf(p, today);
          const name = displayName(p);
          return (
            <li key={p.id}>
              <a href={`#/patient/${p.id}`}>
                <span class="pav">{initialsOf(name)}</span>
                <span class="pinfo">
                  <span class="pnm">{name}</span>
                  <span class="pmeta">
                    {[
                      p.gender === 'female' ? t.female : p.gender === 'male' ? t.male : '',
                      age ? t.age(age) : '',
                      mrnOf(p) ? `MRN ${mrnOf(p)}` : '',
                    ]
                      .filter(Boolean)
                      .join(' · ')}
                  </span>
                </span>
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

const initialsOf = (name: string) =>
  (
    name
      .split(/\s+/)
      .map((s) => s[0] ?? '')
      .join('')
      .slice(0, 2) || '—'
  ).toUpperCase();
